import { FC, useState } from 'react';
import { Box, Chip, IconButton, Menu } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import { commentReactionToggle } from '../../slices/commentSlice';

// Fixed reaction palette (no external emoji-picker dependency).
const EMOJIS = ['👍', '❤️', '🎉', '👀', '🙌', '✅'];

interface ReactionBarProps {
  comment: any;
}

export const ReactionBar: FC<ReactionBarProps> = ({ comment }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const reactions = comment.reactions || [];

  const toggle = (emoji: string) => {
    dispatch(commentReactionToggle(comment.id, emoji) as any);
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center', mt: 0.5 }}>
      {reactions.map((r: any) => (
        <Chip
          key={r.emoji}
          size="small"
          label={`${r.emoji} ${r.count}`}
          variant={r.reactedByMe ? 'filled' : 'outlined'}
          color={r.reactedByMe ? 'primary' : 'default'}
          onClick={() => toggle(r.emoji)}
        />
      ))}
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <AddIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <Box sx={{ display: 'flex', px: 1 }}>
          {EMOJIS.map((e) => (
            <IconButton key={e} size="small" onClick={() => toggle(e)}>
              <span style={{ fontSize: 18 }}>{e}</span>
            </IconButton>
          ))}
        </Box>
      </Menu>
    </Box>
  );
};
